export function initializeMobileMenu() {
     const toggles = document.querySelectorAll(".mobile-toggle");

     toggles.forEach((toggle) => {
          if (toggle.dataset.mobileMenuInitialized) return;
          toggle.dataset.mobileMenuInitialized = true;

          const menu = document.querySelector(".mobile-menu");

          toggle.addEventListener("click", function () {
               this.classList.toggle("active");
               if (menu) {
                    menu.classList.toggle("open");
                    menu.classList.toggle("active");
               }
          });
     });

     // Target the clickable area inside menu-item-has-children
     document.querySelectorAll(".mobile-nav .menu-item-has-children > .mobile-menu-item").forEach((item) => {
          if (item.dataset.submenuInitialized) return;
          item.dataset.submenuInitialized = true;

          item.addEventListener("click", function (e) {
               e.preventDefault();
               e.stopPropagation();

               const li = item.closest(".menu-item-has-children");
               const subMenu = li ? li.querySelector(".sub-menu") : null;

               if (subMenu) {
                    const isOpen = li.classList.contains("active");

                    // Collapse siblings
                    const parentUl = li.closest("ul");
                    if (parentUl) {
                         parentUl.querySelectorAll(".menu-item-has-children.active").forEach((openLi) => {
                              if (openLi !== li) {
                                   openLi.classList.remove("active");
                                   const openSubMenu = openLi.querySelector(".sub-menu");
                                   if (openSubMenu) {
                                        openSubMenu.classList.remove("active");
                                        openSubMenu.style.maxHeight = null;
                                   }
                              }
                         });
                    }

                    // Toggle current
                    li.classList.toggle("active", !isOpen);
                    subMenu.classList.toggle("active", !isOpen);

                    if (!isOpen) {
                         subMenu.style.maxHeight = subMenu.scrollHeight + "px";
                    } else {
                         subMenu.style.maxHeight = null;
                    }
               }
          });
     });
}